module.exports = __webpack_public_path__ + "img/bg_avatar_female_56.b0268ee7.png";